import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div
        data-testid="protected-loading"
        className="min-h-screen bg-[color:var(--sr-bg)] flex items-center justify-center"
      >
        <p className="label-eyebrow text-[color:var(--sr-muted)] flex items-center gap-3">
          <span className="w-2 h-2 rounded-full bg-[color:var(--sr-accent)] animate-pulse" />
          Loading
        </p>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ returnTo: loc.pathname }} />;
  }
  return children;
}
